import { render, staticRenderFns } from "./WordPress.vue?vue&type=template&id=1fc5b136&"
import script from "./WordPress.vue?vue&type=script&lang=js&"
export * from "./WordPress.vue?vue&type=script&lang=js&"
import style0 from "./WordPress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc5b136')) {
      api.createRecord('1fc5b136', component.options)
    } else {
      api.reload('1fc5b136', component.options)
    }
    module.hot.accept("./WordPress.vue?vue&type=template&id=1fc5b136&", function () {
      api.rerender('1fc5b136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/WordPress.vue"
export default component.exports